<template>
    <div class="training-tile" >
        <div class="training-tile__image" :style="`background-image: url('${assignment.image}');`"></div>

        <div v-if="!isCompleted" class="training-tile__icon training-tile__icon--not-completed">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.994 0C5.364 0 0 5.37 0 12C0 18.63 5.364 24 11.994 24C18.624 24 24 18.63 24 12C24 5.37 18.624 0 11.994 0ZM12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 6.696 6.696 2.4 12 2.4C17.304 2.4 21.6 6.696 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM12.6 6H10.8V13.2L17.094 16.98L18 15.504L12.6 12.3V6Z" fill="white"/>
            </svg>
        </div>

        <div v-else class="training-tile__icon training-tile__icon--completed">
            <svg width="24" height="24" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.276923 10.1538C0.0923077 9.96923 0 9.69231 0 9.50769C0 9.32308 0.0923077 9.04615 0.276923 8.86154L1.56923 7.56923C1.93846 7.2 2.49231 7.2 2.86154 7.56923L2.95385 7.66154L8.03077 13.1077C8.21538 13.2923 8.49231 13.2923 8.67692 13.1077L21.0462 0.276923H21.1385C21.5077 -0.0923077 22.0615 -0.0923077 22.4308 0.276923L23.7231 1.56923C24.0923 1.93846 24.0923 2.49231 23.7231 2.86154L8.95385 18.1846C8.76923 18.3692 8.58462 18.4615 8.30769 18.4615C8.03077 18.4615 7.84615 18.3692 7.66154 18.1846L0.461538 10.4308L0.276923 10.1538Z" fill="white"/>
            </svg>
        </div>

        <div class="training-tile__information">
            <div class="training-tile__status">
                {{ assignment.status_trans }}
            </div>

            <div class="training-tile__title">
                {{ assignment.course_title }}
            </div>

            <div class="training-tile__description" v-html="assignment.description ? assignment.description.split(' ').splice(0, 20).join(' ') + ' ...' : null"></div>
        </div>

        <div class="training-tile__buttons">
            <a
                v-if="showCertificateButton"
                role="button"
                class="btn btn--primary"
                :href="route('tenant.trainings.certificate', assignment.course_id)"
                >
                {{ trans('trainings.button.certificate') }}
            </a>

            <a
                role="button"
                :class="[{'btn btn--primary': !showCertificateButton}, {'btn btn--secondary': showCertificateButton}]"
                :href="route('tenant.trainings.show', assignment.course_id)"
                >
                {{ trans('trainings.page_title.show') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'assignment',
    ],

    computed: {
        showCertificateButton() {
            return this.assignment.is_certifiable && this.isCompleted;
        },

        isCompleted() {
            return this.assignment.status == 'completed';
        }
    }
}
</script>
